import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Formik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import { USER_DATETIME_FORMAT } from "@utils/datetime";
import UserUtil from "@utils/user";
import moment from "moment";
import User from "@services/User";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  formContent: {
    width: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
    "@media all and (min-width: 768px)": {
      width: "592px",
    },
  },
  stateCell: {
    display: "flex",
    alignItems: "center",
  },
}));

const USER_GROUP = "member";

function UsersMaintenanceDialog(props) {
  const classes = useStyles();
  const params = useParams();
  const userId = params.user && params.user !== "novo" ? params.user : "";

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  function isNewMode() {
    return !userId;
  }

  function isEditMode() {
    return !!userId;
  }

  function renderDateCell(value) {
    if (!value) {
      return "---";
    }
    return moment(value).format(USER_DATETIME_FORMAT);
  }

  function createUser(values) {
    setLoading(true);
    User.createUser(USER_GROUP, {
      username: values.userName,
      name: values.name,
      email: values.email,
    })
      .then(() => {
        toast.success("Usuário criado!");
        setLoading(false);
        handleSuccess();
      })
      .catch((e) => {
        console.error(e);
        toast.error("Erro ao criar usuário!");
        setLoading(false);
      });
  }

  function editUser(values) {
    setLoading(true);
    User.updateUser(values.userName, {
      username: values.userName,
      name: values.name,
      email: values.email,
    })
      .then(() => {
        toast.success("Usuário atualizado!");
        setLoading(false);
        handleSuccess();
      })
      .catch((e) => {
        console.error(e);
        toast.error("Erro ao atualizar usuário!");
        setLoading(false);
      });
  }

  function handleClickSubmit(values) {
    if (isNewMode()) {
      createUser(values);
    } else if (isEditMode()) {
      editUser(values);
    }
  }

  function handleClose() {
    if (!loading) {
      props.onCancel();
    }
  }

  function handleSuccess() {
    if (!loading) {
      props.onSuccess();
    }
  }

  function handleClickCancel() {
    if (!loading) {
      props.onCancel();
    }
  }

  function loadUserData() {
    setLoading(true);
    User.find(userId)
      .then((user) => {
        setUser(user);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Erro ao carregar dados do usuário!");
        setLoading(false);
      });
  }

  useEffect(() => {
    if (userId) {
      loadUserData();
    }
  }, [userId]);

  const defaultInitialValues = {
    name: "",
    userName: "",
    email: "",
  };
  let initialValues;
  if (isNewMode() || !user) {
    initialValues = defaultInitialValues;
  } else {
    initialValues = {
      name: UserUtil.findUserAttribute(user, "name"),
      userName: user.Username,
      email: UserUtil.findUserAttribute(user, "email"),
    };
  }

  const validationRules = {
    name: Yup.string().required("Campo obrigatório"),
    userName: Yup.string().required("Campo obrigatório"),
    email: Yup.string().required("Campo obrigatório").email("Email inválido"),
  };

  const validationSchema = Yup.object().shape(validationRules);

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnMount
      >
        {({ errors, touched, isValid, values, handleChange, handleBlur }) => (
          <React.Fragment>
            <DialogTitle>
              {!userId && "Novo usuário"}
              {userId && "Editar usuário"}
            </DialogTitle>
            <DialogContent className={classes.formContent}>
              <Grid container spacing={3}>
                {user && (
                  <React.Fragment>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2">Login:</Typography>
                      <Typography variant="body1">{user.Username}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2">E-mail:</Typography>
                      <Typography variant="body1">
                        {UserUtil.findUserAttribute(user, "email")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2">
                        Data de Criação:
                      </Typography>
                      <Typography variant="body1">
                        {renderDateCell(user.UserCreateDate)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle2">
                        Data de Modificação:
                      </Typography>
                      <Typography variant="body1">
                        {renderDateCell(user.UserLastModifiedDate)}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                )}
                {/* user */}
                <Grid item xs={12}>
                  <TextField
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.name ? errors.name : ""}
                    error={touched.name && Boolean(errors.name)}
                    variant="outlined"
                    required
                    fullWidth
                    label="Nome"
                    name="name"
                  />
                </Grid>
                {!user && (
                  <>
                    <Grid item xs={12} sm={5}>
                      <TextField
                        value={values.userName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.userName ? errors.userName : ""}
                        error={touched.userName && Boolean(errors.userName)}
                        variant="outlined"
                        required
                        fullWidth
                        label="Login"
                        name="userName"
                      />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <TextField
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.email ? errors.email : ""}
                        error={touched.email && Boolean(errors.email)}
                        variant="outlined"
                        required
                        fullWidth
                        label="E-mail"
                        name="email"
                      />
                    </Grid>
                  </>
                )}
                {/* end user */}
              </Grid>
            </DialogContent>
            {/* control */}
            <DialogActions>
              <Button onClick={handleClickCancel} disabled={loading}>
                Cancelar
              </Button>
              <Button
                disabled={!isValid || loading}
                onClick={() => {
                  handleClickSubmit(values);
                }}
                color="primary"
              >
                {isNewMode() && "Criar"}
                {isEditMode() && "Salvar"}
              </Button>
            </DialogActions>
            {/* end control */}
          </React.Fragment>
        )}
      </Formik>
    </Dialog>
  );
}

UsersMaintenanceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

UsersMaintenanceDialog.defaultProps = {
  open: false,
  onCancel: () => {},
  onSuccess: () => {},
};

export default UsersMaintenanceDialog;
